/**
 * @description Формулы для полей "Тариф Банка", "Итоговая комиссия", "Комиссия агента".
 * Все значения должны округляться до двух знаков после запятой.
 *
 * Больше про формулы смотреть на Wiki https://shaboldalab.ru/frontend/kgbFront/-/wikis/home
 * */
export const calculateBaseCommission = (
  bgSumm: number,
  bankRate: number,
  deltaDays: number
): number => {
  const result = (
    (bgSumm * (bankRate * 0.01) * (deltaDays + 1)) / // увеличивать дни на 1 из-за особенности рассчета
    365
  ).toFixed();
  if (Number(result) < 890) return 890;
  return Number(result);
};

export const calculateFinalCommission = (
  baseCommission: number,
  overstatement: number
): number => {
  const result = (baseCommission + overstatement).toFixed();
  return Number(result);
};

export const calculateAgentCommission = (
  baseCommission: number,
  overstatement: number
): number => {
  const result = (baseCommission * 0.35 + overstatement).toFixed();
  return Number(result);
};
